export const getCookie = (name: string): string | null =>
  document.cookie
    .split(';')
    .map((x) => x.split('='))
    .filter(([k]) => k.trim() === name)
    .map(([_k, v]) => decodeURIComponent(v))[0] ?? null;
